import { BaseModel } from "@blue-chip/core";

export default class QueryReport extends BaseModel {}
